import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-program-achievement-test-reading',
  templateUrl: './program-achievement-test-reading.component.html',
  styleUrls: ['./program-achievement-test-reading.component.scss']
})
export class ProgramAchievementTestReadingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
